// extracted by mini-css-extract-plugin
export default {"title":"GroupCalculationsTitle_title__q81q0"};